/** Normaliza nombre de trabajador (misma lógica que el back). */
export function normalizeTrabajadorKey(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

/**
 * Catálogo local (metadatos). Los valores vienen del servidor en data.ajustes.
 */
export const NOMINAS_AJUSTES = [
  {
    id: "lydia-comisiones-atrasos",
    trabajadorKey: normalizeTrabajadorKey("Uralde Cabanes, Lydia"),
    cuenta: "64000001",
    descuentoMensualDefault: 1043,
    label: "Atrasos comisiones ventas (64000001)",
  },
];

/** Mapa { ajusteId: descuentoMensual } solo para ajustes activos. */
export function descuentosPorAjusteDesdeServidor(ajustesServidor = []) {
  const out = {};
  (ajustesServidor || []).forEach((a) => {
    if (a?.activo && (Number(a.descuentoMensual) || 0) > 0) {
      out[a.id] = Number(a.descuentoMensual);
    }
  });
  return out;
}

/**
 * Calcula descuento anual y por mes para un trabajador según sus líneas contables.
 */
export function calcularDescuentosTrabajador(trabajador, ajustes, descuentosPorAjuste = {}) {
  const key = normalizeTrabajadorKey(trabajador?.label);
  const lineas = trabajador?.lineas || [];
  let descuentoTotal = 0;
  const descuentoPorMes = {};
  const detalle = [];

  (ajustes || []).forEach((ajuste) => {
    if (ajuste.trabajadorKey !== key) return;
    const linea = lineas.find((l) => String(l.cuenta) === String(ajuste.cuenta));
    if (!linea) return;

    const descuentoMensual = descuentosPorAjuste[ajuste.id] ?? 0;
    if (!descuentoMensual) return;

    let subtotal = 0;
    const mesesAfectados = {};
    for (let m = 1; m <= 12; m++) {
      const mk = String(m);
      if ((linea.meses?.[mk] || 0) > 0) {
        mesesAfectados[mk] = descuentoMensual;
        descuentoPorMes[mk] = (descuentoPorMes[mk] || 0) + descuentoMensual;
        subtotal += descuentoMensual;
      }
    }
    if (subtotal > 0) {
      descuentoTotal += subtotal;
      detalle.push({
        ajusteId: ajuste.id,
        label: ajuste.label,
        cuenta: ajuste.cuenta,
        descuentoMensual,
        descuentoAnual: subtotal,
        mesesAfectados,
      });
    }
  });

  return { descuentoTotal, descuentoPorMes, detalle };
}

/** Aplica ajustes a la lista de trabajadores para la gráfica. */
export function trabajadoresConAjustes(trabajadores, ajustes, descuentosPorAjuste = {}) {
  return (trabajadores || []).map((t) => {
    const { descuentoTotal, descuentoPorMes, detalle } = calcularDescuentosTrabajador(
      t,
      ajustes,
      descuentosPorAjuste,
    );
    const totalContable = Number(t.total) || 0;
    const totalAjustado = Math.max(0, totalContable - descuentoTotal);
    const mesesAjustados = {};
    for (let m = 1; m <= 12; m++) {
      const mk = String(m);
      const base = t.meses?.[mk] || 0;
      const desc = descuentoPorMes[mk] || 0;
      if (base > 0 || desc > 0) {
        mesesAjustados[mk] = Math.max(0, base - desc);
      }
    }
    return {
      ...t,
      totalContable,
      totalAjustado,
      tieneAjuste: descuentoTotal > 0,
      descuentoTotal,
      descuentoPorMes,
      ajustesDetalle: detalle,
      mesesAjustados,
    };
  });
}
